import Modules from 'application/modules';
import { Alexa, Anonymizer, Bootstrap, Devices, List, ListNumbered, NPVR, Power, RTF, World } from 'assets/svg';
import authService from 'core/auth';
import { VipocGroup } from 'core/auth/constants';
import { ShortcutGroup } from 'modules/home/shortcut';
import groupBy from 'ramda/es/groupBy';
import { Component } from 'react';
import { ShortcutProps } from './shortcut/shortcut-component';

const shortcuts: Array<ShortcutProps> = [
  {
    title: 'home.icon_device',
    icon: <Devices className="icon-svg icon-large" />,
    link: '/operational/device',
    category: 'home.label_operational',
    group: Modules.devices
  },

  {
    title: 'home.icon_id_mapping',
    icon: <List className="icon-svg icon-large" />,
    link: '/management/id-mapping',
    category: 'home.label_management',
    group: Modules.idMapping
  },

  {
    title: 'home.icon_ip_whitelist',
    icon: <World className="icon-svg icon-large" />,
    link: '/management/ip-geolocation',
    category: 'home.label_management',
    group: Modules.ipGeolocation
  },

  {
    title: 'home.icon_onnet_offnet',
    icon: <Power className="icon-svg icon-large" />,
    link: '/management/on-net-off-net',
    category: 'home.label_management',
    group: Modules.onNetOffNet
  },

  {
    title: 'home.icon_esn_mapping',
    icon: <ListNumbered className="icon-svg icon-large" />,
    link: '/management/esn-mapping',
    category: 'home.label_management',
    group: Modules.esnMapping
  },

  {
    title: 'home.icon_alexa',
    icon: <Alexa className="icon-svg icon-large" />,
    link: '/management/alexa-capability',
    category: 'home.label_management',
    group: Modules.alexaCapability
  },

  {
    title: 'home.icon_anonymizer',
    icon: <Anonymizer className="icon-svg icon-large" />,
    link: '/management/anonymizer',
    category: 'home.label_management',
    group: Modules.anonymizer
  },

  {
    title: 'home.icon_bootstrap',
    icon: <Bootstrap className="icon-svg icon-large" />,
    link: '/management/bootstrap',
    category: 'home.label_management',
    group: Modules.bootstrap
  },

  {
    title: 'home.icon_rtf',
    icon: <RTF className="icon-svg icon-large" />,
    link: '/operational/rtf',
    category: 'home.label_operational',
    group: Modules.rtf
  },

  {
    title: 'home.icon_npvr',
    icon: <NPVR className="icon-svg-filled fill-on-hover no-width icon-large" />,
    link: '/operational/npvr',
    category: 'home.label_operational',
    group: Modules.devices
  },
];

const filterByPermission = (shortcut: ShortcutProps) => {
  const user = authService.getCurrentUser();
  const currentOpco = authService.getCurrentOpco();

  return (
    !shortcut.group ||
    user.groups.filter(
      (group: VipocGroup) => group.moduleName === shortcut.group && group.opco === currentOpco
    ).length > 0
  );
};

const shortcutsByCategory = groupBy(
  (shortcut) => shortcut.category,
  shortcuts.filter(filterByPermission)
);

export default class HomeComponent extends Component {
  render() {
    const user = authService.getCurrentUser();

    if (!user.token) {
      authService.logoutAndRedirect()
      return null
    }

    if (Object.keys(shortcutsByCategory).length === 0) {
      authService.switchOpco(`${user.opcos[0]}`);
      return null;
    }

    return (
      <div className="has-margin-md">
        {Object.keys(shortcutsByCategory).map((category, key) => (
          <ShortcutGroup title={category} key={key} shortcuts={shortcutsByCategory[category]} />
        ))}
      </div>
    );
  }
}
